"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditTrail = void 0;
require("./audit-trail.less");
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community/dist/styles/ag-theme-balham.css");
const ag_grid_react_1 = require("ag-grid-react");
const audit_trail_header_1 = require("./components/audit-trail-header");
const react_1 = require("react");
const mobx_react_1 = require("mobx-react");
const store_1 = require("client/modules/reporting/store");
const transaction_details_1 = require("client/modules/orders/modules/orders-detail/components/order-claims/transaction-details");
const ui_1 = require("client/components/ui");
const React = require("react");
const no_data_found_1 = require("../no-data-found/no-data-found");
const store_2 = require("client/modules/orders/store");
const mobx_1 = require("mobx");
const store_3 = require("client/modules/users/store");
const store_4 = require("client/modules/sites/modules/sites-list/store");
let AuditTrail = class AuditTrail extends react_1.Component {
    constructor(props) {
        super(props);
        this.erxLogData = []; // B-096.2
        this.onLoading = true; // B-096.2
        this.renderTransactionModal = () => {
            if (!this.transactionData)
                return;
            const { requests, responses, rxId, siteName: name, timezone } = this.transactionData;
            const missingProps = {
                order: { site: { name, timezone } },
                rxId: { rxId }
            };
            const selectedRow = Object.assign(Object.assign({}, this.transactionData), missingProps);
            selectedRow.requests = JSON.parse(requests);
            selectedRow.responses = JSON.parse(responses);
            return (React.createElement(transaction_details_1.TransactionDetails, { claim: selectedRow, erxLog: this.erxLogData, onCancel: () => {
                    this.transactionData = null;
                } }));
        };
        /**
       * get erx data while click on view claim data. B-096.2
       * function is used to get the each and every ERX tranmission date and time
       */
        this.getErxDataOnView = async (claimId) => {
            var _a;
            this.onLoading = false; // B-096.2
            let filteredData = [];
            const result = await store_2.ordersStore.readERXLog(claimId); //B-096.2
            const erxLogs = result.value; //B-096.2
            (_a = (erxLogs || [])) === null || _a === void 0 ? void 0 : _a.map((item) => {
                var _a;
                (_a = (erxLogs || [])) === null || _a === void 0 ? void 0 : _a.filter((data) => {
                    if (item.id === data.logReference) {
                        filteredData.push(item, data);
                    }
                });
            });
            this.erxLogData = filteredData || []; //B-096.2
            this.onLoading = true; // B-096.2
        };
        this.onRowClicked = async (row) => {
            const { data } = row;
            if (data.EventType === "claim") {
                await this.getErxDataOnView(data.ClaimId); //B-096.2
                const transactionData = await store_2.ordersStore.loadTransactionData(data.ClaimId);
                this.transactionData = transactionData;
            }
        };
        this.onButtonExport = () => {
            const params = {
                fileName: "Audit_Trail.csv"
            };
            this.storeData.gridApi.exportDataAsCsv(params);
        };
        this.storeData = {
            columnDefs: [
                {
                    enableRowGroup: true,
                    field: "PharmacyName",
                    headerName: "Pharmacy Name"
                },
                {
                    enableRowGroup: true,
                    field: "UserName",
                    headerName: "User Name"
                },
                {
                    field: "EventDate",
                    filter: "agDateColumnFilter",
                    filterParams: {
                        browserDatePicker: true,
                        comparator: (filterLocalDateAtMidnight, cellValue) => {
                            const dateAsString = cellValue;
                            if (dateAsString === null)
                                return -1;
                            const dateParts = dateAsString.split("/");
                            const cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
                            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                                return 0;
                            }
                            if (cellDate < filterLocalDateAtMidnight) {
                                return -1;
                            }
                            if (cellDate > filterLocalDateAtMidnight) {
                                return 1;
                            }
                        }
                    },
                    headerName: "Date",
                    width: 180
                },
                {
                    field: "EventTime",
                    headerName: "Time (EST)",
                    width: 140
                },
                {
                    field: "EventType",
                    headerName: "Category",
                    width: 120
                },
                {
                    field: "EventID",
                    headerName: "Category Reference #",
                    width: 200
                },
                {
                    field: "EventAction",
                    headerName: "Action",
                    width: 300
                }
            ],
            defaultColDef: {
                comparator(a, b) {
                    if (typeof a === "string") {
                        return a.localeCompare(b);
                    }
                    return a > b ? 1 : a < b ? -1 : 0;
                },
                enablePivot: true,
                enableRowGroup: true,
                enableValue: true,
                filter: true,
                resizable: true,
                sortable: true
            },
            floatingFilter: true,
            multiSortKey: "ctrl",
            rowData: [],
            rowSelection: "single"
        };
    }
    async filtersSites() {
        const user = store_3.usersStore.user.value.sites || null;
        const result = store_4.sitesListStore.sites.value.filter((site, i) => user.includes(site.id));
        return result;
    }
    async componentDidMount() {
        await store_1.reportsStore.loadUserAuditTrail();
    }
    componentWillUnmount() {
        store_1.reportsStore.auditTrailData = null;
    }
    render() {
        let isAdminDev = (store_3.usersStore.user.value.groupId == 1 || store_3.usersStore.user.value.groupId == 4) ? true : false;
        const storeData = store_1.reportsStore.auditTrailData;
        // B-097
        this.storeData.rowData = storeData;
        let filteredPharmacy = [];
        let matchedPharmacies = [];
        this.filtersSites().then((result) => {
            filteredPharmacy = result;
            const filteredArray = this.storeData.rowData.map((item1) => (Object.assign({}, item1)));
            for (let audit of filteredArray) {
                for (let assignPharmacy of filteredPharmacy) {
                    if (audit.PharmacyName === assignPharmacy.displayName
                    // audit.UserID === usersStore.user.value.id
                    ) {
                        matchedPharmacies.push(audit);
                    }
                }
            }
            this.storeData.updatedPharmacy = matchedPharmacies;
        });
        const loadingData = store_1.reportsStore.showLoader;
        if (!this.onLoading) {
            return (React.createElement("div", { style: { display: "float", marginLeft: "50%", marginTop: "10%" } },
                React.createElement(ui_1.UiLoadingIndicator, null)));
        } // B-096.2
        if (storeData && storeData.length > 0) {
            return (React.createElement(React.Fragment, null,
                React.createElement(audit_trail_header_1.AuditTrailHeader, { title: "Audit Trail", withDatePicker: true }),
                React.createElement("div", { className: "ag-theme-balham", style: {
                        height: "85%",
                        width: "100%"
                    } },
                    React.createElement("button", { onClick: this.onButtonExport.bind(this) }, "Export to CSV"),
                    React.createElement(ag_grid_react_1.AgGridReact, { animateRows: true, columnDefs: this.storeData.columnDefs, defaultColDef: this.storeData.defaultColDef, floatingFilter: this.storeData.floatingFilter, frameworkComponents: this.storeData.frameworkComponents, groupMultiAutoColumn: true, multiSortKey: this.storeData.multiSortKey, onGridReady: params => (this.storeData.gridApi = params.api), onRowClicked: this.onRowClicked, rowData: isAdminDev ? this.storeData.rowData : this.storeData.updatedPharmacy, rowSelection: this.storeData.rowSelection, sideBar: true, suppressExcelExport: true })),
                this.renderTransactionModal()));
        }
        if (storeData) {
            if (loadingData) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(audit_trail_header_1.AuditTrailHeader, { title: "Audit Trail", withDatePicker: true }),
                    React.createElement("div", null, "Loading Data...")));
            }
            // Return a Custom built component here to handle 0 data returned.
            return (React.createElement(no_data_found_1.default, { headerComponent: React.createElement(audit_trail_header_1.AuditTrailHeader, { title: "Audit Trail", withDatePicker: true }) }));
        }
        return React.createElement(ui_1.UiLoadingIndicator, null);
    }
};
__decorate([
    mobx_1.observable
], AuditTrail.prototype, "transactionData", void 0);
__decorate([
    mobx_1.observable
], AuditTrail.prototype, "erxLogData", void 0);
__decorate([
    mobx_1.observable
], AuditTrail.prototype, "onLoading", void 0);
AuditTrail = __decorate([
    mobx_react_1.observer
], AuditTrail);
exports.AuditTrail = AuditTrail;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/audit-trail/audit-trail.tsx
// module id = 3871
// module chunks = 0